var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filled',{attrs:{"id":parseInt(_vm.$route.params.id, 10),"userId":_vm.$route.params.userId,"printable":true,"printMode":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }